import React from 'react';
import { Link } from 'react-router-dom';
import { NewspaperIcon, ArrowRightIcon, ShieldAlertIcon } from 'lucide-react';
import { AfterTideLayout } from '../../components/AfterTide/AfterTideLayout';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
export default function Community() {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const articles = [{
    id: 'a1',
    title: "Navigating Tier 4 Content: A Reader's Guide",
    category: 'Platform Guide',
    date: 'Oct 15, 2024',
    excerpt: 'Understanding the jump from Tier 3 to Tier 4, and how to use our progressive warning system to protect your peace.',
    image: 'https://images.unsplash.com/photo-1455390582262-044cdead2708?w=600&q=80'
  }, {
    id: 'a2',
    title: 'Author Spotlight: S.R. Cross',
    category: 'Interviews',
    date: 'Oct 10, 2024',
    excerpt: 'The author of Velvet Shadows discusses world-building, writing morally grey vampires, and the importance of aftercare in fiction.',
    image: 'https://images.unsplash.com/photo-1474366521946-c3d4b507abf2?w=600&q=80'
  }, {
    id: 'a3',
    title: 'The Rise of Monster Romance',
    category: 'Genre Deep Dive',
    date: 'Oct 02, 2024',
    excerpt: 'Why readers are increasingly turning to non-human love interests to explore complex power dynamics and unconditional acceptance.',
    image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=600&q=80'
  }];
  return <AfterTideLayout data-id="element-4667" data-mp="53ern5fa86yf">
      <div className={`min-h-screen ${dk.page} py-12`} data-id="element-4668" data-mp="52vbnu96zsn1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4669" data-mp="a2ho41h754us">
          <div className="text-center mb-16" data-id="element-4670" data-mp="a0odkb3gq0hi">
            <NewspaperIcon className={`h-12 w-12 mx-auto mb-4 ${rt.textPrimary}`} data-id="element-4671" data-mp="1gjcyd2mzmgwh" />
            <h1 className={`font-playfair text-5xl font-bold ${dk.textPrimary} mb-4`} data-id="element-4672" data-mp="1lgv6iqt6ks3f">
              The Midnight Dispatch
            </h1>
            <p className={`text-lg ${dk.textSecondary} max-w-2xl mx-auto`} data-id="element-4673" data-mp="3clybdbjnoqx8">
              Articles, interviews, and guides from the AfterTide editorial
              team.
            </p>
          </div>

          {/* Featured Article */}
          <div className={`${dk.surface} border ${dk.border} rounded-2xl overflow-hidden mb-12 group cursor-pointer hover:border-[#e2b04a]/50 transition-colors`} data-id="element-4674" data-mp="3ml71tufbbneu">
            <div className="flex flex-col md:flex-row" data-id="element-4675" data-mp="2tw9p06tveith">
              <div className="md:w-1/2 h-64 md:h-auto relative" data-id="element-4676" data-mp="2ttnhg76zc3b9">
                <img src={articles[0].image} alt={articles[0].title} className="w-full h-full object-cover" data-id="element-4677" data-mp="37og2fl5n2bp8" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a2e] to-transparent md:hidden" data-id="element-4678" data-mp="2f5ivmucmrbo9" />
              </div>
              <div className="md:w-1/2 p-8 md:p-12 flex flex-col justify-center" data-id="element-4679" data-mp="2b4qkfvk76wpc">
                <div className="flex items-center gap-3 mb-4" data-id="element-4680" data-mp="210a7b9y3rtp8">
                  <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${rt.bgMedium} ${rt.textPrimary}`} data-id="element-4681" data-mp="25sacphwxzet7">
                    {articles[0].category}
                  </span>
                  <span className={`text-sm ${dk.textMuted}`} data-id="element-4682" data-mp="1w30l0360fy5m">
                    {articles[0].date}
                  </span>
                </div>
                <h2 className={`font-playfair text-3xl md:text-4xl font-bold ${dk.textPrimary} mb-4 group-hover:text-[#e2b04a] transition-colors`} data-id="element-4683" data-mp="2jpp77121ycs1">
                  {articles[0].title}
                </h2>
                <p className={`text-lg ${dk.textSecondary} mb-8`} data-id="element-4684" data-mp="2ernmycsw47ez">
                  {articles[0].excerpt}
                </p>
                <div className={`flex items-center font-bold ${rt.accentLink}`} data-id="element-4685" data-mp="ycnho7zmfuuh">
                  Read Article{' '}
                  <ArrowRightIcon className="h-5 w-5 ml-2 transform group-hover:translate-x-2 transition-transform" data-id="element-4686" data-mp="13b7387aaz4mb" />
                </div>
              </div>
            </div>
          </div>

          {/* Guidelines Banner */}
          <div className={`mb-12 p-6 rounded-xl border border-[#c77dba]/30 bg-[#c77dba]/5 flex flex-col sm:flex-row items-center justify-between gap-6`} data-id="element-4687" data-mp="19ud9yvwvw2i2">
            <div className="flex items-center gap-4" data-id="element-4688" data-mp="14tfkdy9jo66j">
              <div className="p-3 bg-[#c77dba]/20 rounded-full" data-id="element-4689" data-mp="22i953w6t1mcq">
                <ShieldAlertIcon className="h-6 w-6 text-[#c77dba]" data-id="element-4690" data-mp="1xkh1i4wssbsp" />
              </div>
              <div data-id="element-4691" data-mp="1sl4ftnhnxarp">
                <h3 className={`font-bold ${dk.textPrimary} mb-1`} data-id="element-4692" data-mp="1skl6uw9zpwpt">
                  Community Guidelines
                </h3>
                <p className={`text-sm ${dk.textSecondary}`} data-id="element-4693" data-mp="1nl893ghkz58g">
                  Review our rules for discussing sensitive content in reviews
                  and book clubs.
                </p>
              </div>
            </div>
            <button className={`whitespace-nowrap px-6 py-2 rounded-lg text-sm font-medium border border-[#c77dba]/50 text-[#c77dba] hover:bg-[#c77dba]/10 transition-colors`} data-id="element-4694" data-mp="c8z6a6cuy5fx">
              Read Guidelines
            </button>
          </div>

          {/* Article Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4695" data-mp="2xqb28yls4mlb">
            {articles.slice(1).map(article => <div key={article.id} className={`${dk.surface} border ${dk.border} rounded-xl overflow-hidden group cursor-pointer hover:border-[#e2b04a]/50 transition-colors`} data-id="element-4696" data-mp="37i7c16x8a15d">
                <div className="h-48 relative" data-id="element-4697" data-mp="3gilyi9lxhmag">
                  <img src={article.image} alt={article.title} className="w-full h-full object-cover" data-id="element-4698" data-mp="3ggsqoqzkww0v" />
                </div>
                <div className="p-6" data-id="element-4699" data-mp="1m6yxu6gcurm5">
                  <div className="flex items-center gap-3 mb-3" data-id="element-4700" data-mp="1r3fiurs9cpv0">
                    <span className={`text-[10px] font-bold px-2 py-1 rounded border ${dk.borderAccentStrong} ${dk.textSecondary} uppercase tracking-wider`} data-id="element-4701" data-mp="1r5s8lr49c4im">
                      {article.category}
                    </span>
                    <span className={`text-xs ${dk.textMuted}`} data-id="element-4702" data-mp="1t30d265pnbfv">
                      {article.date}
                    </span>
                  </div>
                  <h3 className={`font-playfair text-2xl font-bold ${dk.textPrimary} mb-3 group-hover:text-[#e2b04a] transition-colors`} data-id="element-4703" data-mp="221vlzq052zmv">
                    {article.title}
                  </h3>
                  <p className={`text-sm ${dk.textSecondary}`} data-id="element-4704" data-mp="2bqlvdmxidpvw">
                    {article.excerpt}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </AfterTideLayout>;
}